import { BcmOrder } from '@shared/models/bcm-order';
import { BcmOrderStatusType } from '@shared/models/bcm-order-status';

export function isOrderOpenForBookingLink(status: BcmOrderStatusType): boolean {
    return status !== BcmOrderStatusType.Done
        && status !== BcmOrderStatusType.Payed
        && status !== BcmOrderStatusType.Cancelled;
}

export function filterOrdersForBookingClient(
    orders: readonly BcmOrder[],
    personId: number | null,
    companyId: number | null,
): BcmOrder[] {
    const clientId = personId ?? companyId;

    if (!clientId) {
        return [];
    }

    return orders.filter((order) => {
        if (!isOrderOpenForBookingLink(order.lastStatus)) {
            return false;
        }

        const orderClientId = order.client?.id ?? order.clientCompany?.id;

        return orderClientId === clientId;
    });
}

export function pickDefaultOrderIdForBooking(
    orders: readonly BcmOrder[],
    boatId: number | null,
): number | null {
    if (!orders.length) {
        return null;
    }

    if (boatId != null) {
        const boatMatch = orders.find((order) =>
            (order.boats || []).some((boat) => boat.id === boatId),
        );

        if (boatMatch) {
            return boatMatch.id;
        }
    }

    return orders[0]?.id ?? null;
}

export function formatOrderOptionLabel(order: BcmOrder): string {
    const number = order.orderNumber || String(order.id);
    const title = (order.orderTitle || '').trim();

    return title ? `${number} – ${title}` : number;
}
